// extracted by mini-css-extract-plugin
export var messageSideLeft = "_l4-1";
export var messageSideRight = "_l4-2";
export var orderLookupBubbleContainer = "_l4-0";
export var submitButton = "_l4-3";